// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"239":"aecfe591","923":"aecfe591"}[chunkId] + ".css";
};